const mEditionExitModal = {
  mEditionExitModal: {
    buttonCancel: 'Continuar',
    buttonPrimary: 'Regresar',

    message: 'Los cambios realizados no se guardarán si continúas, ¿Quieres regresar para completar los cambios?',
    title: 'Hay cambios sin guardar'
  }
}

export default mEditionExitModal
